import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      
      <p class="text-center bold mb-3">* * *</p>
      
      <p class="mb-3">
        Дул ветер с моря. 
        Он приносил в город запах солёных волн, водорослей, свежести и простора. 
        Он разгонял удушливую вонь выхлопных газов, серый туман безнадёжности и отчаяния, стоящий над городом; он врывался в приморские переулки, 
        пахнущие гнилью и застоявшимся безразличием к собственной жизни. 
        Ветер с моря вымывал город, выдувая из него скопившиеся мусор и грязь. 
        Весёлая весенняя уборка! – Дул ветер с моря.
      </p>
      
      <p class="mb-3">
        В этот день он вышел навстречу ветру. 
        Много лет назад он любил этот ветер… он сливался своей силой с его силой, растворяясь в его могуществе, вбирая в себя весь мир, 
        и каждой клеточкой, каждой молекулой своей сливаясь с каждой молекулой мира в весёлой и буйной мощи ветра. 
        Это было его могущество, его равно-сильность миру. 
        Его сила, его жизнь были равны силе и жизни мира.
      </p>
      
      <p class="mb-3">
        Это время давно прошло. 
        Тридцать лет – чья-то полная сил и свершений жизнь; а у него – <b>н и ч е г о</b>. 
        Всё, что в юности обещало плоды, что росло мощно, гордо и высоко – скукожилось и высохло бесплодно. 
        Цветы так и завяли цветами.
      </p>
      
      <p class="mb-3">
        Он ничего не создал, не написал – ни в науке, ни в литературе. 
        Жена давно вышла за другого, и уже умерла; дети выросли и стали совсем не тем, что он ожидал. 
      </p>
      
      <p class="mb-3">
        Никакие ожидания не сбылись. 
      </p>
      
      <p class="mb-3">
        Ненужно прожитая жизнь не оставила никакого следа. 
        Ни в нём, ни в других.
      </p>
      
      <p class="mb-3">
        Но ветер с моря выдувал со старых улиц застой и грязь!
      </p>
      
      <p class="mb-3">
        И когда в одном из пустых и чистых переулков из-за поворота вышла она, он даже не очень удивился. 
        Исчезло время, исчезло пространство; был только ветер с моря. 
        А он, как известно, создаёт своё пространство и время, и в нём может произойти всё, что угодно. 
        В ветре все измерения закручиваются, создавая мир для одного, отдельный континуум, оживший сон.
      </p>
      
      <p class="mb-3">
        А во сне всё можно. 
        Он подошёл к ней, будто знал её всегда. 
      </p>
      
      <p class="mb-3">
        Она радостно ответила ему.
      </p>
      
      <p class="mb-3">
        Они были созданы друг для друга, но не нашли друг друга в этом мире; а в мире сна, в мире Несбывшегося они пришли друг к другу, 
        потому что иначе и не могло быть. 
        Где-то же должны сбываться Законы Жизни!
      </p>
      
      <p class="mb-3">
        И в этом мире всё сбылось. 
        Они прожили вместе долгую жизнь, полную любви и самоотдачи во имя другого. И как ни странно, оказалось, что отдавая, ты становишься богаче, 
        и помогая другому во имя любви, ты делаешь счастливой и свою жизнь…
      </p>
      
      <p class="mb-3">
        Он стал известным художником, она – доктором наук; но его картины рождались в её душе, он писал то, что она чувствовала, 
        видела в своей душе – и картины были их общим. 
        А в своих исследованиях живого она развивала его мысли, понимала его пониманием, - и её исследования были их общим. 
        Каждый из них был и собой, и другим, был орудием для выражения другого, 
        - и в этом закольцованном мире они жили один другим и один для другого, таким образом абсолютно и полно выражая самого себя. 
      </p>
      
      <p class="mb-3">
        Каждую минуту своей жизни они проживали наполненно, 
        упиваясь своей радостью и любовью и всё время чувствуя напряжение пружинящего потока жизни, несущего их. 
        Их не било, не захлёстывало, не волочило. 
        Они шли на гребне волны, и вся сила волн, сила ветра была их силой!
      </p>
      
      <p class="mb-3">
        Их не задела разруха, не разъела гниль отчаяния. 
        Их успехи не были обусловлены конъюнктурой, они были <b>н а с т о я щ и м и</b>, - и поэтому и при новом режиме их заслуги признавались, 
        финансовое положение не пошатнулось, а возможностей вокруг даже стало больше, и мир заиграл новыми гранями.
      </p>
      
      <p class="mb-3">
        Их дети, выросшие в атмосфере любви и уважения, впитали в себя эту атмосферу и выросли полноценными людьми, с душой и умом. 
        С отличием кончив школу, они уехали учиться: сын в Москву, в МГУ, а дочь в Италию, в консерваторию по классу вокала. 
        Их письма родителям были полны любви и заботы. 
        Так прошло 30 лет. 
        Они всего достигли, и жизнь была полна радостью и счастьем. 
      </p>
      
      <p class="mb-3">
        Но однажды, когда они в весенний ветреный день пошли к берегу моря, вдруг ветер… перестал дуть, и их охватила тишина. 
      </p>
      
      <p class="mb-3">
        Тишина, небытие, смерть… 
        Он стоял в узком переулочке, ведущем к морю, перед поворотом… один…
      </p>
      
      <p class="mb-3">
        Ветер спал; только рядом ещё крутились маленькие смерчики, закручивая в спираль бумажки и окурки. 
        Потом и они упали на землю. 
        Всё остановилось. 
        И время пошло вперёд, по линейке, как ему и положено идти. 
        Пространство вытянулось перед ним в ровную перспективу. 
        Сейчас он завернёт за угол и выйдет к морю. 
      </p>
      
      <p class="mb-3">
        Со всей силой отчаяния он рванулся вперёд. 
        Впереди всё было ровно и пусто. 
      </p>
      
      <p class="mb-3">
        Где-то далеко, в другом мире, так же беспомощно и отчаянно рвалась она; 
        - но прямая дорога из непересекающихся линий вела её всё дальше от него, в ровные ряды пространства и времени, в никуда, в ничто…
      </p>
      
      <p class="mb-3">
        Мгновение, пушинка… но пушинка упала вниз, как свинцовая гиря. 
        Ветра не было. 
      </p>
      
      <p class="mb-3">
        И тогда они замерли, отказавшись идти вперёд. 
        Без жизни – не нужно течение времени, называемое жизнью. 
        Они отказались идти по прямым, - бессмысленно, в никуда. 
        Они отказались принимать жизнь, которая не была жизнью. 
      </p>
      
      <p class="mb-3">
        Неизвестно, что он делает сейчас. 
        Может, присутствует на рабочем месте; может, читает или спит. 
        Может, ест или разговаривает.
      </p>
      
      <p class="mb-3">
        Но каждый раз, когда поднимается ветер с моря, он идёт к морю и ждёт.
      </p>
      
      <p class="mb-3">
        И там идёт его настоящая жизнь; а ветер с моря кружится, кружится вокруг него.
      </p>
    

    </div>
    `
  )
}

const itemName = {
  rus: `Дул ветер с моря`
}

const itemDate = {
  rus: `10 февраля 2001 г.`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;